import { Link } from "react-router-dom";
import Masthead from "./Masthead";
import { Button } from "./ui/button";
import { MODULES } from "../lib/modules";
import { useAuth } from "../lib/auth";
import { DatabaseZap, Plug } from "lucide-react";

/**
 * EmptyModule — live empty-state for real/production tenants that have no
 * data yet (is_demo === false). Shown in place of a module dashboard until a
 * connector feeds it.
 */
export default function EmptyModule({ moduleKey }) {
  const { user, tenant } = useAuth();
  const mod = MODULES.find((m) => m.key === moduleKey);
  const label = mod?.label || "This module";
  const isAdmin = user && (user.role === "super_admin" || user.role === "org_admin");

  return (
    <>
      <Masthead
        eyebrow="Live workspace"
        title={label}
        subtitle={`${tenant?.name || "This organisation"} — awaiting live data`}
      />
      <div className="ciso flex-1 flex items-center justify-center" style={{ padding: "48px 26px" }}>
        <div
          className="ciso-panel text-center"
          data-testid="empty-module"
          style={{ maxWidth: 480, padding: "44px 34px" }}
        >
          <div
            className="mx-auto mb-5 flex items-center justify-center"
            style={{ width: 58, height: 58, borderRadius: 16, background: "var(--cv-sand)" }}
          >
            <DatabaseZap className="w-7 h-7" style={{ color: "var(--cv-crimson)" }} />
          </div>
          <h3 className="text-[19px] font-bold small-caps" style={{ color: "var(--cv-charcoal)" }}>
            No data yet
          </h3>
          <p className="text-[13.5px] mt-2 leading-relaxed" style={{ color: "var(--cv-dark-grey)" }}>
            {label} has no data for this organisation yet. Connect a security tool to start
            populating this dashboard with your live environment.
          </p>
          {isAdmin ? (
            <Link to="/connectors">
              <Button
                className="mt-6"
                data-testid="empty-connect-btn"
                style={{ background: "var(--cv-crimson)", color: "#fff" }}
              >
                <Plug className="w-4 h-4 mr-1.5" /> Connect a source
              </Button>
            </Link>
          ) : (
            <p className="text-[12.5px] mt-5" style={{ color: "var(--cv-dark-grey)" }}>
              Ask an administrator to connect a data source.
            </p>
          )}
        </div>
      </div>
    </>
  );
}
